import ChatAppConfig from './chat/ChatAppConfig';
import AIChatAppConfig from './ai-chat/AIChatAppConfig';
import ContactsAppConfig from './contacts/ContactsAppConfig';
import ClientsAppConfig from './clients/ClientsAppConfig';
import HelpCenterAppConfig from './help-center/HelpCenterAppConfig';
import ProfileAppConfig from './profile/profileAppConfig';
import HomeAppConfig from './home/HomeAppConfig';
import GroupsAppConfig from './groups/GroupsAppConfig';
import TeamsAppConfig from './teams/TeamsAppConfig';
import AdminAppConfig from './admin/AdminAppConfig';
import AccountAppConfig from './account/AccountAppConfig';
import AcceptTermsAppConfig from './accept-terms/AcceptTermsAppConfig';
import AccountReturnAppConfig from './account/AccountReturnAppConfig';
import ReferralsAppConfig from './referrals/ReferralsAppConfig';
import OrganizationsAppConfig from './organizations/OrganizationsAppConfig';
import SchedulingAppConfig from './scheduling/SchedulingAppConfig';
import SchedulingCronofyReturnAppConfig from './scheduling/SchedulingCronofyReturnAppConfig';
import MyTasksAppConfig from './my-tasks/MyTasksAppConfig';
import SettingsAppConfig from './settings/SettingsAppConfig';

const appsConfigs = [
  ContactsAppConfig,
  ChatAppConfig,
  AIChatAppConfig,
  ClientsAppConfig,
  HelpCenterAppConfig,
  ProfileAppConfig,
  HomeAppConfig,
  GroupsAppConfig,
  TeamsAppConfig,
  AdminAppConfig,
  AccountAppConfig,
  AcceptTermsAppConfig,
  AccountReturnAppConfig,
  ReferralsAppConfig,
  OrganizationsAppConfig,
  SchedulingAppConfig,
  SchedulingCronofyReturnAppConfig,
  MyTasksAppConfig,
  SettingsAppConfig
];

export default appsConfigs;
